import { useLocalizationContext } from '@im/react-localization';
import { CopyRightTO } from '@im/ui-lib/types';
import { useApiQuery } from 'mf_core/query';
import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router';

export function usePartnerWithUs(enabled: boolean) {
  const { locale } = useLocalizationContext();
  const navigate = useNavigate();
  const query = useApiQuery<GetCopyRightsResponseTO>(
    `/cms-noauth/v1/quick-links`,
    {
      type: 'PartnerWithUs',
      typelang: locale,
    },
    { enabled },
    undefined,
    { isLogoutApi: true }
  );
  const data = query.data?.items?.length ? query.data.items[0] : undefined;
  const onClick = useCallback(() => {
    if (data) {
      if (data.openUrlInNewTab) {
        window.open(data.url, '_blank');
      } else if (data.url?.startsWith('/cep/app/')) {
        navigate(data.url?.replace('/cep/app/', '/') ?? '/');
      } else {
        window.open(data.url, '_self');
      }
    }
  }, [data, navigate]);

  return useMemo(() => {
    return data
      ? ({
          onClick,
          openUrlInNewTab: data.openUrlInNewTab,
          title: data.title,
          trackingTag: data.trackingTag,
          url: data.url,
        } as CopyRightTO)
      : undefined;
  }, [data, onClick]);
}

type GetCopyRightsResponseTO = {
  items: QuickLinkDataTO[];
};

type QuickLinkDataTO = {
  isModel: boolean;
  onClick: string;
  openUrlInNewTab: boolean;
  title: string;
  trackingTag: string;
  url: string;
};
